import React, { useEffect, useState } from 'react'
import { Header, Table, Groupper, useFrontier, Input } from 'react-frontier2';
import { Link, useNavigate } from 'react-router-dom';
import { addCommas, fromUnix, getNow } from '@arema/components/Util';
import { DateTime } from 'luxon';
import API from '../../API';

interface DatePayments {
	date: string,
	orders: number,
}

function DatePaymentsList() {
	var { Toast } = useFrontier();
	var navigate = useNavigate();
	var [payments, setPayments] = useState<DatePayments[]>(null);
	var [date, setDate] = useState<number>(null);

	useEffect(() => {
		getTablaDia(7);
	}, []);

	var getTablaDia = (days: number) => {
		API.getDatePaymentsList(date, days).then(res => {
			if (res.error) return Toast.error('Error al cargar los datos (LCL-01)');
			setPayments(res.data);
		}).catch(err => {
			return Toast.error('Error inesperado (LCL-02)');
		})
	}

	var onDateSelected = (d: Date)=>{
		return navigate(`/conciliacion/tabla/${DateTime.fromJSDate(d).toFormat('yyyy-MM-dd')}`);
	}

	if(payments===null) {
		return <Header text="Cargando Ordenes" loading />
	}

	return (
		<Groupper title={'Tabla del día'} style={{ maxWidth: 500, margin: 'auto' }}>
			<Input placeholder='Seleccionar día' iconName='calendar' calendar={{
				date: date ? fromUnix(date).toJSDate() : null,
				mode: 'date',
				initialDate: getNow().toJSDate(),
				onSelected: onDateSelected,
				maxDate: getNow().toJSDate(),
			}} />
			<Table fitted striped selectable>
				<Table.Head 
					collapsingIndexes={[1]}
					centeredIndexes={[1]}
					data={[['Fecha', 'Pagos']]}
				/>
				<Table.Body>
					{payments.map(a=>(
						<Table.Row compact
							collapsingIndexes={[1]}
							centeredIndexes={[1]}
							as={Link}
							to={`/conciliacion/tabla/${a.date}`}
							data={[a.date, addCommas(a.orders, false)]}
						/>
					))}
				</Table.Body>
			</Table>
		</Groupper>
	)
}

export default DatePaymentsList;
